<template>
  <div class="fee-undo">
    <div class="header">
      <el-input class="query" v-model.trim="orderNo" placeholder="请输入订单号" clearable @keyup.native.enter="getBillList(1)" @clear="getBillList(1)"></el-input>
      <el-button type="primary" @click="getBillList(1)">查询</el-button>
      <fee-undo-invoicing class="invoice-btn" :selectList="selectList" @saveSuccess="getBillList(1)"></fee-undo-invoicing>
    </div>
    <Table :data="list" :columns="columns" :pages="pages" @selection-change="selectionChange" selection :showIndex="false"></Table>
  </div>
</template>
<script>
import InvoiceService from "@/apis/InvoiceService";
import orderService from "@/apis/orderService";
import Table from "@/components/new-table.vue";
import FeeUndoInvoicing from "./fee-undo-invoicing.vue";
import { OrderTypeLabel } from "@/service/enum"
export default {
  components: { Table, FeeUndoInvoicing },
  data() {
    return {
      orderNo: "",
      list: [],
      selectList: [],
      columns: [
        { label: "订单号", prop: "orderNo" },
        { label: "应用名称", prop: "appName", "min-width": "80px" },
        { label: "套餐名称", prop: "packageName", "min-width": "110px" },
        {
          label: "购买时长", "min-width": '100px', render: (h, { row }) => {
            let num = row.packagePeriodNum * row.buyNum + (['', '天', '个月'][row.packagePeriodUnit])
            return <div> {num}</div>
          }
        },
        {
          label: "付款金额", prop: "payMoney", "min-width": '100px', render: (h, { row }) => {
            return <div> {orderService.toYuan(row.payMoney)} </div>
          }
        },
        {
          label: "平台服务费", prop: "platformMoney", "min-width": "110px", render: (h, { row }) => {
            return <div> {orderService.toYuan(row.platformMoney)} </div>
          }
        },
        { label: "创建时间", prop: "createDate", "min-width": "110px" },
        {
          label: "订单类型", prop: "maxUsers", "min-width": '90px', render: (h, { row }) => {
            return <div> {OrderTypeLabel[row.type] || ''} </div>
          }
        },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
    }
  },
  mounted() {
    this.getBillList();
  },
  methods: {
    getBillList(pageIndex) {
      const page = pageIndex || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      InvoiceService.getUnInvoiceOrderList(page, pageSize, this.orderNo).then(res => {
        this.list = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getBillList(1);
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getBillList();
    },
    selectionChange(list) {
      this.selectList = list;
    }
  }
}
</script>

<style lang="scss" scoped>
.fee-undo {
  display: flex;
  flex-direction: column;
  width: 100%;

  .header {
    margin-bottom: 20px;
    position: relative;
  }
  .invoice-btn {
    position: absolute;
    right: 10px;
    top: 0;
  }
  .query {
    width: 200px;
    margin-right: 20px;
    vertical-align: middle;
  }
}
</style>